import { RectSize } from "../../../utils/RectSize";
import { AppSettings } from "../../managers/AppSettings";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { CardData, TextureData } from "../../../types/types";
import { HandsListItem } from "./HandsListItem";
import { ScrollPaneTitledListContent } from "./ScrollPaneTitledListContent";
import { AppLocalization } from "../../localization/AppLocalization";
import { ThemeDataManager } from "../../managers/ThemeDataManager";
import { LayoutDataManager } from "../../managers/LayoutDataManager";


export type DealCompleteHandsContentData = {
    title: string,
    cards: CardData[],
}[];

export class DealCompleteHandsContent
    extends ScrollPaneTitledListContent
{
    public nodeGeneralLoc: any;

    // delimiter line
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected hasDelimiterLine: boolean;
    protected delimiterLineAlpha: number;
    

    public override Init(): void
    {
        // > items
        super.Init();

        this.delimiterLineAlpha = LayoutDataManager.GetSharedData().general.screen.item.delimiterLine.alpha;
        
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.hands;
        this.nodeGeneralLoc = AppLocalization.GetSharedData().general;
        this.nodeTheme = ThemeDataManager.GetVariationData().dealComplete.hands;
    }

    public override Build(): void
    {
        // > build title
        super.Build();
        this.add(this.nsContentBg);

        // refs
        // const itemBgTextureData: TextureData = {texture:LoaderFileKeys.ui, frame:"results-tricks-listItem-bg.png"};
        const itemBgTextureData: TextureData = {texture:LoaderFileKeys.ui, frame:"rect-2x2-transparent.png"};
        const itemLabelTextStyle: Phaser.Types.GameObjects.Text.TextStyle = {
            color: "#fff", 
            fontSize: "36px",
            align: "left", 
            fontFamily: AppSettings.fontFamilies.MontserratBold,
            metrics: AppSettings.metrics.montserratBold36,
        };

        for (let i:number = 0; i<this.nodeGeneralLoc.playersAxes.length; i++) {
            const item = new HandsListItem(this.scene);
            item.Init(
                itemBgTextureData, 
                itemLabelTextStyle,
                LayoutDataManager.GetSharedData().general.screen.header.delimiterLine.alpha,
            );
            item.Build();
            this.items.push(item as any);
            this.add(item);
        }

        // this.UpdateFromLocalizationChange();
    }

    /**
     * Localized language changed. Update text.
     */
    public UpdateFromLocalizationChange(): void
    {
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.hands;
        const sTitle: string = this.nodeLoc.title.itemLabel;

        this.btnTitle.SetLabel(sTitle);
    }

    public SetData(inputData: DealCompleteHandsContentData): void
    {
        this.items.forEach((item, i)=>{
            (item as any).SetData(
                inputData[i].title,
                inputData[i].cards,
                this.items.length != i+1,
            );
        });
    }

    public override SetWidth(width: number): void
    {
        // position and calculate size for all base items
        super.SetWidth(width);
        
        this.RedrawBorder();
    }
}